// import redux and persist plugins
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'reduxjs-toolkit-persist';
import storage from 'reduxjs-toolkit-persist/lib/storage';
import persistStore from 'reduxjs-toolkit-persist/es/persistStore';
import { FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE } from 'reduxjs-toolkit-persist/es/constants';

// import theme reducers
import settingsReducer from 'settings/settingsSlice';
import layoutReducer from 'layout/layoutSlice';
import langReducer from 'lang/langSlice';
import authReducer from 'auth/authSlice';
import menuReducer from 'layout/nav/main-menu/menuSlice';
import notificationReducer from 'layout/nav/notifications/notificationSlice';
import scrollspyReducer from 'components/scrollspy/scrollspySlice';
import productReducer from 'api/productSlice';
import gtmReducer from 'api/gtmSlice';
import reviewReducer from 'api/reviewSlice';
import marketingReducer from 'api/marketingSlice';
import analyticsReducer from 'api/analyticsSlice';
import eComAuthReducer from 'api/authSlice';
import blogReducer from 'api/blogSlice';
import categoryReducer from 'api/categorySlice';
import dashboardReducer from 'api/dashboardSlice';
import ordersReducer from 'api/ordersSlice';
import customerReducer from 'api/customerSlice';
import landingReducer from 'api/landingSlice';
import customCodeReducer from 'api/customCodeSlice';
import shippingChargeReducer from 'api/shippingChargeSlice';
import bannerReducer from 'api/bannerSlice';
import fraudReducer from 'api/fraudSlice';

// import persist key
import { REDUX_PERSIST_KEY } from 'config.js';

const persistConfig = {
  key: REDUX_PERSIST_KEY,
  storage,
  whitelist: ['menu', 'settings', 'lang'],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    layout: layoutReducer,
    lang: langReducer,
    auth: authReducer,
    ecomauth: eComAuthReducer,
    menu: menuReducer,
    notification: notificationReducer,
    scrollspy: scrollspyReducer,
    products: productReducer,
    gtm: gtmReducer,
    marketing: marketingReducer,
    reviews: reviewReducer,
    analytics: analyticsReducer,
    category: categoryReducer,
    blogState: blogReducer,
    dashboard: dashboardReducer,
    orders: ordersReducer,
    customers: customerReducer,
    landing: landingReducer,
    customCode: customCodeReducer,
    shippingCharge: shippingChargeReducer,
    banner: bannerReducer,
    fraud: fraudReducer,
  })
);
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };
